// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e067d8a7","551":"c4b64d3f","828":"d6f1c352"}[chunkId] + ".chunk.js";
};